import {
    VAULT_PATIENT_LIST_REQUEST, VAULT_PATIENT_LIST_SUCCESS, VAULT_PATIENT_LIST_FAIL, VAULT_PATIENT_LIST_RESET,
    VAULT_PATIENT_LIST_BY_IDS_REQUEST, VAULT_PATIENT_LIST_BY_IDS_SUCCESS, VAULT_PATIENT_LIST_BY_IDS_FAIL, VAULT_PATIENT_LIST_BY_IDS_RESET,
    VAULT_PATIENT_DETAILS_REQUEST, VAULT_PATIENT_DETAILS_SUCCESS, VAULT_PATIENT_DETAILS_FAIL, VAULT_PATIENT_DETAILS_RESET,
    VAULT_PATIENT_UPDATE_REQUEST, VAULT_PATIENT_UPDATE_SUCCESS, VAULT_PATIENT_UPDATE_FAIL, VAULT_PATIENT_UPDATE_RESET,
    VAULT_PATIENT_DTO_REQUEST, VAULT_PATIENT_DTO_SUCCESS, VAULT_PATIENT_DTO_FAIL, VAULT_PATIENT_DTO_RESET,
    VAULT_PATIENT_OPT_OUT_REQUEST, VAULT_PATIENT_OPT_OUT_SUCCESS, VAULT_PATIENT_OPT_OUT_FAIL, VAULT_PATIENT_OPT_OUT_RESET,
    VAULT_PATIENT_BACKFILL_REQUEST, VAULT_PATIENT_BACKFILL_SUCCESS, VAULT_PATIENT_BACKFILL_FAIL, VAULT_PATIENT_BACKFILL_RESET,
    VAULT_PATIENT_UPLOAD_BATCHES_REQUEST, VAULT_PATIENT_UPLOAD_BATCHES_SUCCESS, VAULT_PATIENT_UPLOAD_BATCHES_FAIL,
    VAULT_PATIENT_SUB_STUDIES_REQUEST, VAULT_PATIENT_SUB_STUDIES_SUCCESS, VAULT_PATIENT_SUB_STUDIES_FAIL,
    VAULT_SUB_STUDY_LIST_REQUEST, VAULT_SUB_STUDY_LIST_SUCCESS, VAULT_SUB_STUDY_LIST_FAIL, VAULT_SUB_STUDY_LIST_RESET,
    VAULT_SUB_STUDY_LIST_BY_IDS_REQUEST, VAULT_SUB_STUDY_LIST_BY_IDS_SUCCESS, VAULT_SUB_STUDY_LIST_BY_IDS_FAIL, VAULT_SUB_STUDY_LIST_BY_IDS_RESET,
    VAULT_SUB_STUDY_DETAILS_REQUEST, VAULT_SUB_STUDY_DETAILS_SUCCESS, VAULT_SUB_STUDY_DETAILS_FAIL, VAULT_SUB_STUDY_DETAILS_RESET,
    VAULT_SUB_STUDY_DTO_REQUEST, VAULT_SUB_STUDY_DTO_SUCCESS, VAULT_SUB_STUDY_DTO_FAIL, VAULT_SUB_STUDY_DTO_RESET,
    VAULT_SUB_STUDY_CREATE_REQUEST, VAULT_SUB_STUDY_CREATE_SUCCESS, VAULT_SUB_STUDY_CREATE_FAIL, VAULT_SUB_STUDY_CREATE_RESET,
    VAULT_SUB_STUDY_UPDATE_REQUEST, VAULT_SUB_STUDY_UPDATE_SUCCESS, VAULT_SUB_STUDY_UPDATE_FAIL, VAULT_SUB_STUDY_UPDATE_RESET,
    VAULT_SUB_STUDY_DELETE_REQUEST, VAULT_SUB_STUDY_DELETE_SUCCESS, VAULT_SUB_STUDY_DELETE_FAIL, VAULT_SUB_STUDY_DELETE_RESET,
    VAULT_SUB_STUDY_PATIENTS_REQUEST, VAULT_SUB_STUDY_PATIENTS_SUCCESS, VAULT_SUB_STUDY_PATIENTS_FAIL, VAULT_SUB_STUDY_PATIENTS_RESET,
} from '../constants/identifierVaultConstants';

export const vaultPatientListReducer = (state = { vaultPatients: [] }, action) => {
    switch (action.type) {
        case VAULT_PATIENT_LIST_REQUEST:
            return { loading: true, vaultPatients: [] };
        case VAULT_PATIENT_LIST_SUCCESS:
            return {
                loading: false,
                vaultPatients: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case VAULT_PATIENT_LIST_FAIL:
            return { loading: false, vaultPatients: [], error: action.payload };
        case VAULT_PATIENT_LIST_RESET:
            return { vaultPatients: [] };
        default:
            return state;
    }
};

export const vaultPatientListByIdsReducer = (state = { vaultPatients: [] }, action) => {
    switch (action.type) {
        case VAULT_PATIENT_LIST_BY_IDS_REQUEST:
            return { loading: true, vaultPatients: [] };
        case VAULT_PATIENT_LIST_BY_IDS_SUCCESS:
            return {
                loading: false,
                vaultPatients: action.payload,
            };
        case VAULT_PATIENT_LIST_BY_IDS_FAIL:
            return { loading: false, vaultPatients: [], error: action.payload };
        case VAULT_PATIENT_LIST_BY_IDS_RESET:
            return { vaultPatients: [] };
        default:
            return state;
    }
};

export const vaultPatientDetailsReducer = (state = { vaultPatient: {} }, action) => {
    switch (action.type) {
        case VAULT_PATIENT_DETAILS_REQUEST:
            return { loading: true, ...state };
        case VAULT_PATIENT_DETAILS_SUCCESS:
            return { loading: false, vaultPatient: action.payload };
        case VAULT_PATIENT_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case VAULT_PATIENT_DETAILS_RESET:
            return { vaultPatient: {} };
        default:
            return state;
    }
};

export const vaultPatientUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case VAULT_PATIENT_UPDATE_REQUEST:
            return { loading: true };
        case VAULT_PATIENT_UPDATE_SUCCESS:
            return { loading: false, success: true, vaultPatient: action.payload };
        case VAULT_PATIENT_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case VAULT_PATIENT_UPDATE_RESET:
            return {};
        default:
            return state;
    }
};

export const vaultPatientDtoReducer = (state = { vaultPatientDto: {} }, action) => {
    switch (action.type) {
        case VAULT_PATIENT_DTO_REQUEST:
            return { loading: true, vaultPatientDto: {} };
        case VAULT_PATIENT_DTO_SUCCESS:
            return { loading: false, vaultPatientDto: action.payload };
        case VAULT_PATIENT_DTO_FAIL:
            return { loading: false, error: action.payload };
        case VAULT_PATIENT_DTO_RESET:
            return { vaultPatientDto: {} };
        default:
            return state;
    }
};

export const vaultPatientOptOutReducer = (state = {}, action) => {
    switch (action.type) {
        case VAULT_PATIENT_OPT_OUT_REQUEST:
            return { loading: true };
        case VAULT_PATIENT_OPT_OUT_SUCCESS:
            return { loading: false, success: true, vaultPatient: action.payload };
        case VAULT_PATIENT_OPT_OUT_FAIL:
            return { loading: false, error: action.payload };
        case VAULT_PATIENT_OPT_OUT_RESET:
            return {};
        default:
            return state;
    }
};

export const vaultPatientBackfillReducer = (state = {}, action) => {
    switch (action.type) {
        case VAULT_PATIENT_BACKFILL_REQUEST:
            return { loading: true };
        case VAULT_PATIENT_BACKFILL_SUCCESS:
            return { loading: false, success: true, result: action.payload };
        case VAULT_PATIENT_BACKFILL_FAIL:
            return { loading: false, error: action.payload };
        case VAULT_PATIENT_BACKFILL_RESET:
            return {};
        default:
            return state;
    }
};

export const vaultPatientUploadBatchesReducer = (state = { uploadBatches: [] }, action) => {
    switch (action.type) {
        case VAULT_PATIENT_UPLOAD_BATCHES_REQUEST:
            return { loading: true, uploadBatches: [] };
        case VAULT_PATIENT_UPLOAD_BATCHES_SUCCESS:
            return { loading: false, uploadBatches: action.payload };
        case VAULT_PATIENT_UPLOAD_BATCHES_FAIL:
            return { loading: false, uploadBatches: [], error: action.payload };
        default:
            return state;
    }
};

export const vaultPatientSubStudiesReducer = (state = { subStudies: [] }, action) => {
    switch (action.type) {
        case VAULT_PATIENT_SUB_STUDIES_REQUEST:
            return { loading: true, subStudies: [] };
        case VAULT_PATIENT_SUB_STUDIES_SUCCESS:
            return { loading: false, subStudies: action.payload };
        case VAULT_PATIENT_SUB_STUDIES_FAIL:
            return { loading: false, subStudies: [], error: action.payload };
        default:
            return state;
    }
};

export const vaultSubStudyListReducer = (state = { vaultSubStudies: [] }, action) => {
    switch (action.type) {
        case VAULT_SUB_STUDY_LIST_REQUEST:
            return { loading: true, vaultSubStudies: [] };
        case VAULT_SUB_STUDY_LIST_SUCCESS:
            return {
                loading: false,
                vaultSubStudies: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case VAULT_SUB_STUDY_LIST_FAIL:
            return { loading: false, vaultSubStudies: [], error: action.payload };
        case VAULT_SUB_STUDY_LIST_RESET:
            return { vaultSubStudies: [] };
        default:
            return state;
    }
};

export const vaultSubStudyListByIdsReducer = (state = { vaultSubStudies: [] }, action) => {
    switch (action.type) {
        case VAULT_SUB_STUDY_LIST_BY_IDS_REQUEST:
            return { loading: true, vaultSubStudies: [] };
        case VAULT_SUB_STUDY_LIST_BY_IDS_SUCCESS:
            return {
                loading: false,
                vaultSubStudies: action.payload,
            };
        case VAULT_SUB_STUDY_LIST_BY_IDS_FAIL:
            return { loading: false, vaultSubStudies: [], error: action.payload };
        case VAULT_SUB_STUDY_LIST_BY_IDS_RESET:
            return { vaultSubStudies: [] };
        default:
            return state;
    }
};

export const vaultSubStudyDetailsReducer = (state = { vaultSubStudy: {} }, action) => {
    switch (action.type) {
        case VAULT_SUB_STUDY_DETAILS_REQUEST:
            return { loading: true, ...state };
        case VAULT_SUB_STUDY_DETAILS_SUCCESS:
            return { loading: false, vaultSubStudy: action.payload };
        case VAULT_SUB_STUDY_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case VAULT_SUB_STUDY_DETAILS_RESET:
            return { vaultSubStudy: {} };
        default:
            return state;
    }
};

export const vaultSubStudyDtoReducer = (state = { vaultSubStudyDto: {} }, action) => {
    switch (action.type) {
        case VAULT_SUB_STUDY_DTO_REQUEST:
            return { loading: true, vaultSubStudyDto: {} };
        case VAULT_SUB_STUDY_DTO_SUCCESS:
            return { loading: false, vaultSubStudyDto: action.payload };
        case VAULT_SUB_STUDY_DTO_FAIL:
            return { loading: false, error: action.payload };
        case VAULT_SUB_STUDY_DTO_RESET:
            return { vaultSubStudyDto: {} };
        default:
            return state;
    }
};

export const vaultSubStudyCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case VAULT_SUB_STUDY_CREATE_REQUEST:
            return { loading: true };
        case VAULT_SUB_STUDY_CREATE_SUCCESS:
            return { loading: false, success: true, vaultSubStudy: action.payload };
        case VAULT_SUB_STUDY_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case VAULT_SUB_STUDY_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const vaultSubStudyUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case VAULT_SUB_STUDY_UPDATE_REQUEST:
            return { loading: true };
        case VAULT_SUB_STUDY_UPDATE_SUCCESS:
            return { loading: false, success: true, vaultSubStudy: action.payload };
        case VAULT_SUB_STUDY_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case VAULT_SUB_STUDY_UPDATE_RESET:
            return {};
        default:
            return state;
    }
};

export const vaultSubStudyDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case VAULT_SUB_STUDY_DELETE_REQUEST:
            return { loading: true };
        case VAULT_SUB_STUDY_DELETE_SUCCESS:
            return { loading: false, success: true, id: action.payload };
        case VAULT_SUB_STUDY_DELETE_FAIL:
            return { loading: false, error: action.payload };
        case VAULT_SUB_STUDY_DELETE_RESET:
            return {};
        default:
            return state;
    }
};

export const vaultSubStudyPatientsReducer = (state = { vaultPatients: [] }, action) => {
    switch (action.type) {
        case VAULT_SUB_STUDY_PATIENTS_REQUEST:
            return { loading: true, vaultPatients: [] };
        case VAULT_SUB_STUDY_PATIENTS_SUCCESS:
            return {
                loading: false,
                vaultPatients: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case VAULT_SUB_STUDY_PATIENTS_FAIL:
            return { loading: false, vaultPatients: [], error: action.payload };
        case VAULT_SUB_STUDY_PATIENTS_RESET:
            return { vaultPatients: [] };
        default:
            return state;
    }
};
